import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Button, Modal } from 'react-bootstrap';
import update from 'immutability-helper';
import diff from 'object-diff';
import moment from 'moment';

import EventDetail from './EventDetail';
import EventDetailForm from './EventDetailForm';

function getInitialValues(event) {
  // Shim place obj to work with redux-form better
  if (event.place) {
    return update(event, {
      place: {
        $set: event.place.id,
      },
    });
  }
  return event;
}
const normalizeDate = value => {
  if (Object.prototype.hasOwnProperty.call(value, 'value')) {
    return value.value.format('YYYY-MM-DD');
  }
  if (moment.isMoment(value)) {
    return value.format('YYYY-MM-DD');
  }
  return value;
};

class EventDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddEvent = this.handleAddEvent.bind(this);
    this.handleEditEvent = this.handleEditEvent.bind(this);
    this.handleRemoveEvent = this.handleRemoveEvent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    const initialValues = getInitialValues(this.props.event);
    const isNew = this.props.event.id ? false : true;
    if (isNew) {
      return this.handleAddEvent(values, initialValues);
    }
    return this.handleEditEvent(values, initialValues);
  }
  handleAddEvent(values, initialValues) {
    const submitValues = values;
    submitValues.tour = this.props.tourId;
    if (values.place) {
      submitValues.place = { id: values.place };
    }
    if (submitValues.end) {
      submitValues.end = normalizeDate(submitValues.end);
    }
    if (submitValues.start) {
      submitValues.start = normalizeDate(submitValues.start);
    }
    if (this.props.event.event_type !== 'stay' && submitValues.start) {
      submitValues.end = submitValues.start;
    }
    this.props.addEvent(submitValues);
    this.props.onClose();
  }
  handleEditEvent(values, initialValues) {
    const changedValues = diff(initialValues, values);
    const submitValues = changedValues;
    if (changedValues.place) {
      submitValues.place = { id: changedValues.place };
    }
    if (submitValues.end) {
      submitValues.end = normalizeDate(submitValues.end);
    }
    if (submitValues.start) {
      submitValues.start = normalizeDate(submitValues.start);
    }
    // TODO: Handle if start is modified, set end to same value
    if (this.props.event.event_type !== 'stay' && submitValues.start) {
      submitValues.end = submitValues.start;
    }
    this.props.editEvent(this.props.event.id, submitValues);
    this.props.onClose();
  }
  handleRemoveEvent() {
    this.props.removeEvent(this.props.event.id);
    this.props.onClose();
  }
  render() {
    let detail;
    if (this.props.editing) {
      const initialValues = getInitialValues(this.props.event);
      detail = (
        <EventDetailForm
          event={this.props.event}
          initialValues={initialValues}
          editEvent={this.props.editEvent}
          removeEvent={this.handleRemoveEvent}
          onSubmit={this.handleSubmit}
          places={this.props.places}
        />
      );
    } else {
      detail = <EventDetail event={this.props.event} />;
    }
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Event Detail: {this.props.event.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{detail}</Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}

EventDetailModal.propTypes = {
  tourId: PropTypes.number.isRequired,
  event: PropTypes.object.isRequired,
  places: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  editing: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  addEvent: PropTypes.func.isRequired,
  editEvent: PropTypes.func.isRequired,
  removeEvent: PropTypes.func.isRequired,
};

export default EventDetailModal;



// WEBPACK FOOTER //
// src/routes/tours/components/EventDetailModal.js